import { makeStyles } from '@material-ui/core';

export default makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  title: {
    textAlign: 'center',
  },
  box: {
    marginTop: 20,
  }
});
